/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Accountdeleted1Inputs */

const zh_danger_accountdeleted1 = /** @type {(inputs: Danger_Accountdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户已删除`)
};

const en_danger_accountdeleted1 = /** @type {(inputs: Danger_Accountdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account deleted`)
};

const es_danger_accountdeleted1 = /** @type {(inputs: Danger_Accountdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta eliminada`)
};

/**
* | output |
* | --- |
* | "Account deleted" |
*
* @param {Danger_Accountdeleted1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_accountdeleted1 = /** @type {((inputs?: Danger_Accountdeleted1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Accountdeleted1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_accountdeleted1(inputs)
	if (locale === "en") return en_danger_accountdeleted1(inputs)
	return es_danger_accountdeleted1(inputs)
});
export { danger_accountdeleted1 as "danger_accountDeleted" }